import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm, FieldArray, formValueSelector, change } from 'redux-form';
import { Toggle, TextField, SelectField, Checkbox } from 'redux-form-material-ui';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import * as validator from 'helpers/Validator';
import * as format from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';
import { serviceRequestVerbiage } from 'helpers/VerbiageHelper';

import validate from 'components/tenant_application/validate';
import PreferenceField from 'components/shared/PreferenceField';
import EmailSettings from './EmailSettings';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';

import times from 'lodash/times';
import range from 'lodash/range';

const style = {
  button: {
    color: 'white',
    height: '40px',
    textAlign: 'center',
    margin: 'auto',
    marginTop: '10px',
  },
  textField: {
    fontSize: '14px',
    maxWidth: '400px',
    textAlign: 'left',
    margin: 'auto',
    marginTop: '-25px',
  },
  fullWidthField: {
    maxWidth: '100%',
    fontSize: '14px',
    textAlign: 'left',
    margin: 'auto',
    marginTop: '-25px',
  },
  childToggle: {
    width: '75%',
    borderBottom: '1px solid rgba(0,0,0,0.1)',
    marginBottom: '10px',
  },
};

let CompanyPreferenceForm = class extends Component {
  state = {
    childGuarantorPreferenceToggle: false,
  };

  handleEnableReviewClosedMaintenanceRequests = (isChecked) => {
    if (!isChecked) {
      this.props.dispatch(
        change(COMPANY_PREFERENCE_FORM, 'review_closed_maintenance_requests_max_months', null)
      );
      this.props.dispatch(
        change(COMPANY_PREFERENCE_FORM, 'review_closed_maintenance_requests_no_expire', false)
      );
    }
  };
  handleReviewClosedMaintenanceRequestsNoExpire = (isChecked) => {
    if (isChecked) {
      this.props.dispatch(
        change(COMPANY_PREFERENCE_FORM, 'review_closed_maintenance_requests_max_months', null)
      );
    }
  };
  handleParentGuarantorToggle = (isChecked) => {
    // If parent toggle is on, turn on all notification toggles for guarantor
    // If parent toggle is off, turn off all notification toggles for guarantor
    this.props.dispatch(
      change(COMPANY_PREFERENCE_FORM, 'guarantor_service_requests_emails', isChecked)
    );
    this.props.dispatch(change(COMPANY_PREFERENCE_FORM, 'guarantor_notices_emails', isChecked));
    this.props.dispatch(change(COMPANY_PREFERENCE_FORM, 'guarantor_notices_emails', isChecked));
    this.props.dispatch(change(COMPANY_PREFERENCE_FORM, 'guarantor_amenities_emails', isChecked));
    this.props.dispatch(change(COMPANY_PREFERENCE_FORM, 'guarantor_promotions_emails', isChecked));
    this.props.dispatch(change(COMPANY_PREFERENCE_FORM, 'guarantor_payments_emails', isChecked));
    this.props.dispatch(change(COMPANY_PREFERENCE_FORM, 'guarantor_parcels_emails', isChecked));
    this.props.dispatch(change(COMPANY_PREFERENCE_FORM, 'guarantor_surveys_emails', isChecked));
  };
  validateReviewClosedMaintenanceRequestsInMonths = (value, allValues) => {
    if (!allValues.enable_review_closed_maintenance_requests) {
      return;
    }

    if (allValues.review_closed_maintenance_requests_no_expire !== true) {
      return validator.required(value);
    }

    return undefined;
  };
  validateReviewClosedMaintenanceRequestsNoExpire = (value, allValues) => {
    if (!allValues.enable_review_closed_maintenance_requests) {
      return;
    }

    if (allValues.review_closed_maintenance_requests_max_months === undefined) {
      return validator.acceptance(value);
    }

    return undefined;
  };
  render() {
    const { handleSubmit, isAdmin, enableTenantLegalNotices } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <div className="row" style={{ margin: '20px 20px 70px', textAlign: 'center' }}>
          <div className="row">
            <PreferenceField
              toggleValue={this.props.passwordExpirationActive}
              toggleName="password_expiration_active"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.password'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.password.description'
              )}
            >
              <Field
                name="password_expiration_months"
                component={SelectField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.password.floatingLabel'
                )}
                style={style.textField}
                fullWidth
                disabled={!this.props.passwordExpirationActive}
              >
                <MenuItem
                  value={3}
                  primaryText={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.password.3months'
                  )}
                />
                <MenuItem
                  value={6}
                  primaryText={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.password.6months'
                  )}
                />
                <MenuItem
                  value={12}
                  primaryText={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.password.12months'
                  )}
                />
              </Field>
            </PreferenceField>
            <PreferenceField
              toggleName="enable_all_agents_two_factor_auth"
              selectFieldName="all_agents_two_factor_auth"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.twoFactor.agent'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.twoFactor.agent.description'
              )}
            />
            <PreferenceField
              toggleName="enable_all_maintenance_two_factor_auth"
              selectFieldName="all_maintenance_two_factor_auth"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.twoFactor.maintenance'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.twoFactor.maintenance.description'
              )}
            />
            <PreferenceField
              toggleName="enable_lead_two_factor_auth"
              selectFieldName="lead_two_factor_auth"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.twoFactor.lead'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.twoFactor.lead.description'
              )}
            />
            <PreferenceField
              toggleName="certn_softcheck"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.certnSoftCheck'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.certnSoftCheck.description'
              )}
            />
            <PreferenceField
              toggleName="certn_softcheck_us"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.certnSoftCheck.forTheUS'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.certnSoftCheck.forTheUSDescription'
              )}
            />
            <PreferenceField
              toggleValue={this.props.enableShowOnlyScheduledTickets}
              toggleName="enable_show_only_scheduled_tickets_to_workers"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.serviceRequest',
                {
                  serviceRequest: serviceRequestVerbiage('plural'),
                }
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.serviceRequest.description'
              )}
            >
              <Field
                name="show_only_scheduled_tickets_to_workers_option"
                component={SelectField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.toggleLabel.serviceRequest.selectOptions'
                )}
                style={style.textField}
                fullWidth
                disabled={!this.props.enableShowOnlyScheduledTickets}
              >
                <MenuItem
                  value="mobile_web"
                  primaryText={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.toggleLabel.serviceRequest.webMobile'
                  )}
                />
                <MenuItem
                  value="mobile"
                  primaryText={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.toggleLabel.serviceRequest.mobile'
                  )}
                />
              </Field>
            </PreferenceField>
            <PreferenceField
              toggleValue={this.props.leadInactiveAfterMoveout}
              toggleName="lead_inactive_after_moveout"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.inactiveMoveOut'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.inactiveMoveOut.description'
              )}
            >
              <Field
                name="lead_inactive_after_moveout_days"
                component={SelectField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.inactiveMoveOut.labelText'
                )}
                style={style.textField}
                fullWidth
                disabled={!this.props.leadInactiveAfterMoveout}
              >
                <MenuItem
                  value={0}
                  primaryText={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.inactiveMoveOut.immediately'
                  )}
                />
                <MenuItem
                  value={1}
                  primaryText={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.inactiveMoveOut.1Day'
                  )}
                />
                <MenuItem
                  value={3}
                  primaryText={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.inactiveMoveOut.3Day'
                  )}
                />
                <MenuItem
                  value={5}
                  primaryText={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.inactiveMoveOut.5Day'
                  )}
                />
                <MenuItem
                  value={14}
                  primaryText={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.inactiveMoveOut.14Day'
                  )}
                />
              </Field>
            </PreferenceField>
            <PreferenceField
              toggleName="enable_send_urgent_notices_to_all_residents"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.enableSendUrgentNotices.label'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.enableSendUrgentNotices.description'
              )}
            />
            <PreferenceField
              toggleName="collect_lead_sin_number_during_application"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.sinNumber'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.sinNumber.description'
              )}
            />
            <PreferenceField
              toggleValue={true}
              toggleName="booking_help_link_toggle"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.customBookingHelper.label'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.customBookingHelper.description'
              )}
              disabled
            >
              <Field
                name="booking_help_link"
                component={TextField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.customBookingHelper.labelText'
                )}
                style={style.textField}
                fullWidth
              />
            </PreferenceField>
            <PreferenceField
              toggleName="applicant_consent_required_for_changes"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.applicantConsentRequiredForChanges.label'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.applicantConsentRequiredForChanges.description'
              )}
            />
            <PreferenceField
              toggleName="automatic_application_assignment"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.autoApplicationAssignment.label'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.autoApplicationAssignment.description'
              )}
            />
            <PreferenceField
              toggleValue={true}
              toggleName="application_help_link_toggle"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.customApplicationHelper.label'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.customApplicationHelper.description'
              )}
              disabled
            >
              <Field
                name="application_help_link"
                component={TextField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.customApplicationHelper.labelText'
                )}
                style={style.textField}
                fullWidth
              />
            </PreferenceField>
            <PreferenceField
              toggleValue={true}
              toggleName="minimum_applicant_age"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.applicantAge.label'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.twoFactor.applicantAge.description'
              )}
              disabled
            >
              <Field
                name="minimum_applicant_age"
                component={TextField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.twoFactor.applicantAge.labelText'
                )}
                style={style.textField}
                validate={[validator.required]}
                fullWidth
              />
            </PreferenceField>
            <PreferenceField
              toggleName="ability_to_delay_unit_assignment"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.abilityToDelayUnitAssignment.label'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.abilityToDelayUnitAssignment.description'
              )}
            />
            <PreferenceField
              toggleName="send_ontario_rta_details"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.sendOntarioRTADetails.label'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.sendOntarioRTADetails.description'
              )}
            />
            <PreferenceField
              toggleName="send_ids_to_yardi_on_app_completion"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.sendIdsToYardi.label'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.sendIdsToYardi.description'
              )}
            />
            <PreferenceField
              toggleName="enable_insurance_purchase_in_tenant_app"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.tenantInsurance'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.tenantInsurance.description'
              )}
            />

            {featureEnabled('legal_documents_as_notices') && (
              <PreferenceField
                shouldHide={!isAdmin}
                toggleValue={enableTenantLegalNotices}
                toggleName="enable_tenant_legal_notices"
                selectFieldName="tenant_legal_notices"
                toggleLabelName={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.tenantLegalNotices'
                )}
                preferenceDescription={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.emailNotifications.tenantLegalNotices.description'
                )}
              />
            )}

            {featureEnabled('external_autopay') && (
              <PreferenceField
                toggleValue={this.props.enableExternalAutopayMinDay}
                toggleName="enable_external_autopay_min_day"
                toggleLabelName={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.externalAutoPay.label'
                )}
                preferenceDescription={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.externalAutoPay.description'
                )}
              >
                <Field
                  name="external_autopay_min_day"
                  component={SelectField}
                  floatingLabelText={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.externalAutoPayDay'
                  )}
                  style={style.textField}
                  fullWidth
                  disabled={!this.props.enableExternalAutopayMinDay}
                >
                  {times(31, (i) => (
                    <MenuItem value={i + 1} primaryText={`${i + 1}`} />
                  ))}
                </Field>
              </PreferenceField>
            )}
            <PreferenceField
              toggleValue={this.props.tenantPaymentLink}
              toggleName="use_payment_link_for_tenants"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.paymentLink'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.paymentLink.description'
              )}
            >
              <Field
                name="custom_payment_provider_name"
                component={TextField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.paymentLink.labelText.provider'
                )}
                style={style.textField}
                validate={[validator.required]}
                fullWidth
                disabled={!this.props.tenantPaymentLink}
              />
              <Field
                name="custom_payment_link_for_tenants"
                component={TextField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.paymentLink.labelText.paymentLink'
                )}
                style={style.textField}
                validate={[validator.required]}
                fullWidth
                disabled={!this.props.tenantPaymentLink}
              />
            </PreferenceField>
            <PreferenceField
              toggleName="include_all_rental_charges_in_prorated_rent"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.includeAllRentalChargesInProratedRent.name'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.includeAllRentalChargesInProratedRent.description'
              )}
            />
            <PreferenceField
              toggleValue={true}
              toggleName="prorated_rent_preference"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.proratedRent.label'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.proratedRent.description'
              )}
              disabled
            >
              <Field
                name="prorate_type"
                component={SelectField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.toggleLabel.proratedRent.label'
                )}
                style={style.fullWidthField}
                fullWidth
              >
                <MenuItem
                  value="yearly"
                  primaryText={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.proratedRent.yearly'
                  )}
                />
                <MenuItem
                  value="monthly"
                  primaryText={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.proratedRent.monthly'
                  )}
                />
              </Field>
            </PreferenceField>
            <PreferenceField
              toggleValue={this.props.disable_reviewed_status_change_notification_to_resident}
              toggleName="disable_reviewed_status_change_notification_to_resident"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.emailNotifications.disable_reviewed_status_change_notification_to_resident.label'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.emailNotifications.disable_reviewed_status_change_notification_to_resident.description'
              )}
            />
            <PreferenceField
              toggleName="disable_residents_profile_picture"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.disableResidentsProfilePicture'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.disableResidentsProfilePicture.description'
              )}
            />
            <PreferenceField
              toggleValue
              toggleName="enable_review_closed_maintenance_requests"
              toggleLabelName={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.reviewClosedMaintenanceRequests'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.companyPreferencesForm.toggleLabel.reviewClosedMaintenanceRequests.description'
              )}
              onChange={(e) => this.handleEnableReviewClosedMaintenanceRequests(e.target.checked)}
            >
              <Field
                name="review_closed_maintenance_requests_max_months"
                component={SelectField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.toggleLabel.reviewClosedMaintenanceRequestsInMonths.label'
                )}
                style={style.fullWidthField}
                validate={[this.validateReviewClosedMaintenanceRequestsInMonths]}
                fullWidth
                disabled={this.props.reviewClosedMaintenanceRequestsNoExpire}
              >
                {range(1, 13).map((number) => (
                  <MenuItem
                    key={number}
                    value={number}
                    primaryText={`${number} ${
                      number === 1
                        ? getTranslatedString('monthSingular')
                        : getTranslatedString('monthsPlural')
                    }`}
                  />
                ))}
              </Field>
              <Field
                name="review_closed_maintenance_requests_no_expire"
                component={Checkbox}
                label={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.toggleLabel.reviewClosedMaintenanceRequestsInMonths.noExpire'
                )}
                labelPosition="right"
                validate={[this.validateReviewClosedMaintenanceRequestsNoExpire]}
                onChange={(_, isChecked) =>
                  this.handleReviewClosedMaintenanceRequestsNoExpire(isChecked)
                }
              />
            </PreferenceField>
            {featureEnabled('ui.residents.request_assistance') && (
              <PreferenceField
                toggleValue={this.props.enablePortalAssistanceRequest}
                toggleName="enable_portal_assistance_request"
                selectFieldName="enable_portal_assistance_request"
                toggleLabelName={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.toggleLabel.enableAssistanceRequest'
                )}
                preferenceDescription={getTranslatedString(
                  'landlordPortal.companyPreferencesForm.toggleDescription.enableAssistanceRequest'
                )}
              />
            )}
          </div>
          <div className="row">
            <div className="" style={{ textAlign: 'left', zIndex: '1000', marginTop: '15px' }}>
              <Field
                name="showAutomationSettings"
                component={Toggle}
                label={
                  <strong style={{ fontWeight: '900', fontSize: '16px' }}>
                    {getTranslatedString(
                      'landlordPortal.companyPreferencesForm.toggleLabel.emailNotifications'
                    )}
                  </strong>
                }
              />
            </div>
          </div>
          {this.props.showAutomationSettings && (
            <div>
              <div className="row">
                <hr style={{ marginBottom: '45px', borderTop: '3px solid rgba(0,0,0,0.5)' }} />
                <PreferenceField
                  toggleValue={this.props.enableWelcomePackageDelivery}
                  toggleName="enable_welcome_package_delivery"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.welcomePackage'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.welcomePackage.description'
                  )}
                >
                  <Field
                    name="weeks_before_movein_welcome_package_delivers"
                    component={SelectField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.welcomePackage.labelText'
                    )}
                    style={style.fullWidthField}
                    fullWidth
                    disabled={!this.props.enableWelcomePackageDelivery}
                  >
                    <MenuItem
                      key={`wp_delivery_0`}
                      value={0}
                      primaryText={getTranslatedString(
                        'landlordPortal.companyPreferencesForm.emailNotifications.welcomePackage.menuItem.ASAP'
                      )}
                    />
                    <MenuItem
                      key={`wp_delivery_1`}
                      value={1}
                      primaryText={getTranslatedString(
                        'landlordPortal.companyPreferencesForm.emailNotifications.welcomePackage.menuItem.1week'
                      )}
                    />
                    {range(2, 13).map((i) => (
                      <MenuItem
                        key={`wp_delivery_${i}`}
                        value={i}
                        primaryText={getTranslatedString(
                          `landlordPortal.companyPreferencesForm.emailNotifications.welcomePackage.menuItem.${i}week`
                        )}
                      />
                    ))}
                  </Field>
                </PreferenceField>
                <PreferenceField
                  toggleName="enable_auto_create_tenant_notice_on_ticket_create"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.tenantNoticeTask'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.tenantNoticeTask.description'
                  )}
                />
                <PreferenceField
                  toggleName="show_maintenance_contact"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.showMaintenance'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.showMaintenance.description',
                    { serviceRequest: serviceRequestVerbiage() }
                  )}
                />
                <PreferenceField
                  toggleName="hide_deductions_from_turnover_reports"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.hideDeductionsFromTurnoverReports.label'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.hideDeductionsFromTurnoverReports.description'
                  )}
                />
                <PreferenceField
                  toggleName="enable_show_only_agent_first_name_chat"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.agentName'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.agentName.description'
                  )}
                />
                <PreferenceField
                  toggleName="enable_message_relay_to_inactive_residents"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.messageRelay'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.messageRelay.description'
                  )}
                />
                <PreferenceField
                  toggleValue={this.props.global_amenity_booking_restrictions}
                  toggleName="global_amenity_booking_restrictions"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.globalAmenity'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.globalAmenity.description'
                  )}
                >
                  <div style={{ height: '60px' }}>
                    <div className="col-xs-6" style={{ paddingLeft: 0 }}>
                      <Field
                        name="max_number_amenity_bookings"
                        component={TextField}
                        floatingLabelText={getTranslatedString(
                          'landlordPortal.amenities.restrictions.numberOfBookings'
                        )}
                        style={style.textField}
                        fullWidth
                        disabled={!this.props.global_amenity_booking_restrictions}
                        normalize={format.onlyNumbers}
                      />
                    </div>
                    <div className="col-xs-6" style={{ paddingRight: 0 }}>
                      <Field
                        name="booking_restriction_timeframe"
                        component={SelectField}
                        fullWidth
                        variant="outlined"
                        disabled={!this.props.global_amenity_booking_restrictions}
                        floatingLabelText={getTranslatedString(
                          'landlordPortal.amenities.restrictions.frequency'
                        )}
                        style={style.textField}
                      >
                        <MenuItem
                          value={'weekly_restricted'}
                          primaryText={getTranslatedString(
                            'landlordPortal.amenities.restrictions.frequency.perWeek'
                          )}
                        />
                        <MenuItem
                          value={'monthly_restricted'}
                          primaryText={getTranslatedString(
                            'landlordPortal.amenities.restrictions.frequency.perMonth'
                          )}
                        />
                        <MenuItem
                          value={'yearly_restricted'}
                          primaryText={getTranslatedString(
                            'landlordPortal.amenities.restrictions.frequency.perYear'
                          )}
                        />
                      </Field>
                    </div>
                  </div>
                </PreferenceField>

                <PreferenceField
                  toggleValue={this.props.enableReinviteDysAfterMoveIn}
                  toggleName="enable_reinvite_days_after_movein"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.reinviteMovein'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.reinviteMovein.description'
                  )}
                >
                  <div>
                    <Field
                      name="reinvite_prior_movein_days_option_one"
                      component={SelectField}
                      floatingLabelText={getTranslatedString(
                        'landlordPortal.companyPreferencesForm.emailNotifications.reinviteMovein.labelText'
                      )}
                      style={style.textField}
                      fullWidth
                      disabled={!this.props.enableReinviteDysAfterMoveIn}
                    >
                      <MenuItem
                        value={2}
                        primaryText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.2day'
                        )}
                      />
                      <MenuItem
                        value={5}
                        primaryText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.5day'
                        )}
                      />
                      <MenuItem
                        value={10}
                        primaryText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.10day'
                        )}
                      />
                      <MenuItem
                        value={15}
                        primaryText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.15day'
                        )}
                      />
                    </Field>
                  </div>
                  <div>
                    <Field
                      name="reinvite_prior_movein_days_option_two"
                      component={SelectField}
                      floatingLabelText={getTranslatedString(
                        'landlordPortal.companyPreferencesForm.emailNotifications.reinviteMovein.labelText'
                      )}
                      style={style.textField}
                      fullWidth
                      disabled={!this.props.enableReinviteDysAfterMoveIn}
                    >
                      <MenuItem
                        value={2}
                        primaryText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.2day'
                        )}
                      />
                      <MenuItem
                        value={5}
                        primaryText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.5day'
                        )}
                      />
                      <MenuItem
                        value={10}
                        primaryText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.10day'
                        )}
                      />
                      <MenuItem
                        value={15}
                        primaryText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.15day'
                        )}
                      />
                    </Field>
                  </div>
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.enableReinviteDysPriorMoveIn}
                  toggleName="enable_reinvite_days_prior_movein"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.reinvite'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.description'
                  )}
                >
                  <Field
                    name="reinvite_prior_movein_days"
                    component={SelectField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.labelText'
                    )}
                    style={style.textField}
                    fullWidth
                    disabled={!this.props.enableReinviteDysPriorMoveIn}
                  >
                    <MenuItem
                      value={5}
                      primaryText={getTranslatedString(
                        'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.5day'
                      )}
                    />
                    <MenuItem
                      value={10}
                      primaryText={getTranslatedString(
                        'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.10day'
                      )}
                    />
                    <MenuItem
                      value={15}
                      primaryText={getTranslatedString(
                        'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.15day'
                      )}
                    />
                    <MenuItem
                      value={20}
                      primaryText={getTranslatedString(
                        'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.20day'
                      )}
                    />
                    <MenuItem
                      value={25}
                      primaryText={getTranslatedString(
                        'landlordPortal.companyPreferencesForm.emailNotifications.reinvite.25day'
                      )}
                    />
                  </Field>
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.enableSecondInvitationReminder}
                  toggleName="enable_second_invitation_reminder"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.secondRemind'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.secondRemind.description'
                  )}
                >
                  <Field
                    name="second_invitation_reminder_days"
                    component={SelectField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.secondRemind.labelText'
                    )}
                    style={style.textField}
                    fullWidth
                    disabled={!this.props.enableSecondInvitationReminder}
                  >
                    <MenuItem
                      value={7}
                      primaryText={getTranslatedString(
                        'landlordPortal.companyPreferencesForm.emailNotifications.secondRemind.7day'
                      )}
                    />
                    <MenuItem
                      value={12}
                      primaryText={getTranslatedString(
                        'landlordPortal.companyPreferencesForm.emailNotifications.secondRemind.12day'
                      )}
                    />
                    <MenuItem
                      value={16}
                      primaryText={getTranslatedString(
                        'landlordPortal.companyPreferencesForm.emailNotifications.secondRemind.16day'
                      )}
                    />
                    <MenuItem
                      value={20}
                      primaryText={getTranslatedString(
                        'landlordPortal.companyPreferencesForm.emailNotifications.secondRemind.20day'
                      )}
                    />
                    <MenuItem
                      value={25}
                      primaryText={getTranslatedString(
                        'landlordPortal.companyPreferencesForm.emailNotifications.secondRemind.25day'
                      )}
                    />
                  </Field>
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.applicationDenialNotification}
                  toggleName="enable_application_denial_notification"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.applicationDenial'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.applicationDenial.description'
                  )}
                >
                  <Field
                    name="application_denial_notification_recipient"
                    component={TextField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.recipientEmail'
                    )}
                    style={style.textField}
                    validate={[validator.validEmail]}
                    fullWidth
                    disabled={!this.props.applicationDenialNotification}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.applicationAutoApprovalNotification}
                  toggleName="enable_application_auto_approval_notification"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.applicationAutoApproved'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.applicationAutoApproved.description'
                  )}
                >
                  <Field
                    name="application_auto_approval_notification_recipient"
                    component={TextField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.recipientEmail'
                    )}
                    style={style.textField}
                    validate={[validator.validEmail]}
                    fullWidth
                    disabled={!this.props.applicationAutoApprovalNotification}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.leasesReport}
                  toggleName="enable_leases_report"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.dailyLease'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.dailyLease.description'
                  )}
                >
                  <Field
                    name="leases_report_recipient"
                    component={TextField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.recipientEmail'
                    )}
                    style={style.textField}
                    validate={[validator.required, validator.validEmail]}
                    fullWidth
                    disabled={!this.props.leasesReport}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.weeklyLeasesReport}
                  toggleName="enable_weekly_leases_report"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.weeklyLease'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.weeklyLease.description'
                  )}
                >
                  <Field
                    name="weekly_leases_report_recipient"
                    component={TextField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.recipientEmail'
                    )}
                    style={style.textField}
                    validate={[validator.required, validator.validEmail]}
                    fullWidth
                    disabled={!this.props.weeklyLeasesReport}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.cancelledLeases}
                  toggleName="cancelled_leases"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.cancelledLease'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.cancelledLease.description'
                  )}
                >
                  <Field
                    name="cancelled_leases_email"
                    component={TextField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.recipientEmail'
                    )}
                    style={style.textField}
                    validate={[validator.required, validator.validEmail]}
                    fullWidth
                    disabled={!this.props.cancelledLeases}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.bookingsReport}
                  toggleName="enable_bookings_report"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.dailyBook'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.dailyBook.description'
                  )}
                >
                  <Field
                    name="bookings_report_recipient"
                    component={TextField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.recipientEmail'
                    )}
                    style={style.textField}
                    validate={[validator.required, validator.validEmail]}
                    fullWidth
                    disabled={!this.props.bookingsReport}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.flaggedNotifications}
                  toggleName="notify_on_flag"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.flagged'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.flagged.description'
                  )}
                >
                  <Field
                    name="notify_on_flag_recipient"
                    component={TextField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.recipientEmail'
                    )}
                    style={style.textField}
                    validate={[validator.required, validator.validEmail]}
                    fullWidth
                    disabled={!this.props.flaggedNotifications}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleName="send_insurance_to_property"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.rentersInsuranceConfirmationEmail'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.rentersInsuranceConfirmationEmail.description'
                  )}
                />
                <PreferenceField
                  toggleName="send_amenity_notifications_to_property"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.amenityNotificationEmailToProperty'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.amenityNotificationEmailToProperty.description'
                  )}
                />
                <PreferenceField
                  toggleValue={this.props.tenantNameAndEmailChangeReport}
                  toggleName="enable_tenant_name_and_email_change_reporter"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.nameEmailReport'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.nameEmailReport.description'
                  )}
                >
                  <Field
                    name="tenant_change_events_reporter_recipient"
                    component={TextField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.recipientEmail'
                    )}
                    style={style.textField}
                    validate={[validator.required]}
                    fullWidth
                    disabled={!this.props.tenantNameAndEmailChangeReport}
                  />
                </PreferenceField>

                <PreferenceField
                  toggleValue={this.props.serviceRequestReport}
                  toggleName="enable_service_request_reporter"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.serviceRequestReport',
                    { serviceRequest: serviceRequestVerbiage('titlecase') }
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.description'
                  )}
                >
                  <div className="row">
                    <div className="col-xs-12">
                      <Field
                        name="service_request_reporter_recipient"
                        component={TextField}
                        floatingLabelText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.recipientEmails'
                        )}
                        style={style.textField}
                        validate={[validator.required]}
                        fullWidth
                        disabled={!this.props.serviceRequestReport}
                      />
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: '15px' }}>
                    <div className="col-xs-4">
                      <Field
                        name="service_report_day_of_month"
                        component={SelectField}
                        floatingLabelText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.dayOfMonth'
                        )}
                        validate={[validator.required]}
                        style={style.textField}
                        fullWidth
                        disabled={!this.props.serviceRequestReport}
                      >
                        {range(1, 32).map((i) => (
                          <MenuItem value={i} primaryText={`${i}`} />
                        ))}
                      </Field>
                    </div>

                    <div className="col-xs-4">
                      <Field
                        name="service_report_order_of_day_in_month"
                        component={SelectField}
                        floatingLabelText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.order'
                        )}
                        style={style.textField}
                        validate={[validator.required]}
                        fullWidth
                        disabled={!this.props.serviceRequestReport}
                      >
                        <MenuItem
                          value={'first_days_of_the_month'}
                          primaryText={getTranslatedString(
                            'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.order.first'
                          )}
                        />
                        <MenuItem
                          value={'last_days_of_the_month'}
                          primaryText={getTranslatedString(
                            'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.order.last'
                          )}
                        />
                      </Field>
                    </div>

                    <div className="col-xs-4">
                      <Field
                        name="service_report_month"
                        component={SelectField}
                        floatingLabelText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.month'
                        )}
                        style={style.textField}
                        validate={[validator.required]}
                        fullWidth
                        disabled={!this.props.serviceRequestReport}
                      >
                        <MenuItem
                          value={'current_month_report'}
                          primaryText={getTranslatedString(
                            'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.month.current'
                          )}
                        />
                        <MenuItem
                          value={'prior_month_report'}
                          primaryText={getTranslatedString(
                            'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.month.prior'
                          )}
                        />
                      </Field>
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: '15px' }}>
                    <div className="col-xs-4">
                      <Field
                        name="service_report_day_of_month_secondary"
                        component={SelectField}
                        floatingLabelText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.dayOfMonth'
                        )}
                        validate={[validator.required]}
                        style={style.textField}
                        fullWidth
                        disabled={!this.props.serviceRequestReport}
                      >
                        {range(1, 32).map((i) => (
                          <MenuItem value={i} primaryText={`${i}`} />
                        ))}
                      </Field>
                    </div>

                    <div className="col-xs-4">
                      <Field
                        name="service_report_order_of_day_in_month_secondary"
                        component={SelectField}
                        floatingLabelText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.order'
                        )}
                        style={style.textField}
                        validate={[validator.required]}
                        fullWidth
                        disabled={!this.props.serviceRequestReport}
                      >
                        <MenuItem
                          value={'first_days_of_the_month'}
                          primaryText={getTranslatedString(
                            'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.order.first'
                          )}
                        />
                        <MenuItem
                          value={'last_days_of_the_month'}
                          primaryText={getTranslatedString(
                            'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.order.last'
                          )}
                        />
                      </Field>
                    </div>

                    <div className="col-xs-4">
                      <Field
                        name="service_report_month_secondary"
                        component={SelectField}
                        floatingLabelText={getTranslatedString(
                          'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.month'
                        )}
                        style={style.textField}
                        validate={[validator.required]}
                        fullWidth
                        disabled={!this.props.serviceRequestReport}
                      >
                        <MenuItem
                          value={'current_month_report'}
                          primaryText={getTranslatedString(
                            'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.month.current'
                          )}
                        />
                        <MenuItem
                          value={'prior_month_report'}
                          primaryText={getTranslatedString(
                            'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestReport.month.prior'
                          )}
                        />
                      </Field>
                    </div>
                  </div>
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.autocloseFixedTickets}
                  toggleName="autoclose_fixed_tickets"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.autoCloseFixed'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.autoCloseFixed.description'
                  )}
                >
                  <Field
                    name="desired_ticket_close_period"
                    component={TextField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.autoCloseFixed.hours'
                    )}
                    style={style.textField}
                    validate={[validator.required]}
                    normalize={format.onlyNumbers}
                    fullWidth
                    disabled={!this.props.autocloseFixedTickets}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.autocloseFixedTickets}
                  toggleName="defer_stale_tickets"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.deferStale',
                    { serviceRequest: serviceRequestVerbiage('titlecase') }
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.deferStale.description',
                    { serviceRequest: serviceRequestVerbiage('plural') }
                  )}
                >
                  <Field
                    name="stale_defer_period_in_hours"
                    component={TextField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.deferStale.hours'
                    )}
                    style={style.textField}
                    validate={[validator.required]}
                    normalize={format.onlyNumbers}
                    fullWidth
                    disabled={!this.props.autocloseFixedTickets}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleName="certn_credit_report"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.creditReport'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.creditReport.description'
                  )}
                />
                <PreferenceField
                  toggleName="bypass_application_id"
                  selectFieldName="bypass_application_id"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.bypassID'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.bypassID.description'
                  )}
                />
                <PreferenceField
                  toggleName="enable_tenant_receipts"
                  selectFieldName="tenant_receipts"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.tenantReceipts'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.tenantReceipts.description'
                  )}
                  shouldHide={this.props.yardiEnabled}
                />
                <PreferenceField
                  toggleName="send_ticket_created_emails_to_agents"
                  selectFieldName="send_ticket_created_emails_to_agents"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.serviceRequestCreate',
                    { serviceRequest: serviceRequestVerbiage() }
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.serviceRequestCreate.description',
                    { serviceRequest: serviceRequestVerbiage() }
                  )}
                />
                <PreferenceField
                  toggleName="enable_tenant_maintenance_updates"
                  selectFieldName="tenant_maintenance_updates"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.tenantMaintenanceUpdates'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.tenantMaintenanceUpdates.description',
                    { serviceRequest: serviceRequestVerbiage() }
                  )}
                />
                <PreferenceField
                  toggleName="send_maintenance_ticket_updates"
                  selectFieldName="send_maintenance_ticket_updates"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.maintenanceStaffUpdates'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.maintenanceStaffUpdates.description'
                  )}
                />
                <PreferenceField
                  toggleName="enable_tenant_maintenance_survey"
                  selectFieldName="tenant_maintenance_survey"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.tenantMaintenanceSurvey'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.tenantMaintenanceSurvey.description',
                    { serviceRequest: serviceRequestVerbiage() }
                  )}
                />

                <PreferenceField
                  toggleValue={this.props.enableGoogleReviews}
                  toggleName="google_reviews_active"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.toggleLabel.enableGoogleReviews'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.toggleDescription.enableGoogleReviews'
                  )}
                  shouldHide={!this.props.enableMaintenanceSurveys}
                >
                  <Field
                    name="google_reviews_minimum_rating"
                    component={SelectField}
                    floatingLabelText={`${getTranslatedString(
                      'landlordPortal.companyPreferencesForm.toggleLabel.enableGoogleReviewsHeader'
                    )}*`}
                    style={style.textField}
                    fullWidth
                    disabled={!this.props.enableGoogleReviews}
                  >
                    {range(1, 11).map((day) => (
                      <MenuItem value={day} primaryText={`${day} / 10`} />
                    ))}
                  </Field>
                </PreferenceField>
                <PreferenceField
                  toggleName="force_deposit_credit_card"
                  selectFieldName="force_deposit_credit_card"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.forceCreditCard'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.forceCreditCard.description'
                  )}
                />
                <PreferenceField
                  toggleName="disable_lease_wizard_selections"
                  selectFieldName="disable_lease_wizard_selections"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.disableFieldSelection'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.disableFieldSelection.description'
                  )}
                />
                <PreferenceField
                  toggleName="enable_auto_month_to_month"
                  selectFieldName="auto_month_to_month"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.autoRenewMonth'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.autoRenewMonth.description'
                  )}
                  shouldHide={this.props.yardiEnabled}
                />
                <PreferenceField
                  toggleValue={this.props.autoScheduleBatches}
                  toggleName="auto_schedule_batches"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.toggleLabel.autoScheduleBatches'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.toggleDescription.autoScheduleBatches'
                  )}
                  shouldHide={!this.props.yuhuPaymentsActive}
                >
                  <Field
                    name="auto_schedule_batches_day"
                    component={SelectField}
                    floatingLabelText={`${getTranslatedString(
                      'landlordPortal.companyPreferencesForm.toggleLabel.autoScheduleBatchesHeader'
                    )}*`}
                    style={style.textField}
                    fullWidth
                    disabled={!this.props.autoScheduleBatches}
                  >
                    {range(1, 28).map((day) => (
                      <MenuItem value={day} primaryText={day} />
                    ))}
                  </Field>
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.balanceOwingNotification}
                  toggleName="balance_owing_notification"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.balanceOwingNotification'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.feeRemind.balanceOwingNotificationDescription'
                  )}
                  shouldHide={!this.props.yardiEnabled}
                >
                  <Field
                    name="balance_owing_notification_day"
                    component={SelectField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.balanceOwingNotificationLabel'
                    )}
                    style={style.textField}
                    fullWidth
                    disabled={!this.props.balanceOwingNotification}
                  >
                    {range(1, 15).map((day) => (
                      <MenuItem value={day} primaryText={day} />
                    ))}
                  </Field>
                </PreferenceField>
                <PreferenceField
                  toggleName="enable_renters_insurance_upload_reminder"
                  selectFieldName="renters_insurance_upload_reminder"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.rentersInsuranceRemind'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.rentersInsuranceRemind.description'
                  )}
                />
                <PreferenceField
                  toggleValue={this.props.feeReminder}
                  toggleName="enable_fee_due_reminder"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.feeRemind'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.feeRemind.description'
                  )}
                  shouldHide={this.props.yardiEnabled}
                >
                  <FieldArray
                    name="emailPreferences.fee_due_reminder"
                    component={EmailSettings}
                    selectFieldInterval={1}
                    selectFieldStart={1}
                    selectFieldEnd={5}
                    preferenceParameter={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.emailSettings.preferenceParameter.before'
                    )}
                    selectFieldName="fee_due_reminder"
                    disableSelect={!this.props.feeReminder}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.latePayment}
                  toggleName="enable_create_late_payment"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.latePayment'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.latePayment.description'
                  )}
                  shouldHide={this.props.yardiEnabled}
                >
                  <FieldArray
                    name="emailPreferences.create_late_payment"
                    component={EmailSettings}
                    selectFieldInterval={1}
                    selectFieldStart={1}
                    selectFieldEnd={5}
                    preferenceParameter={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.emailSettings.preferenceParameter.after'
                    )}
                    selectFieldName="create_late_payment"
                    disableSelect={!this.props.latePayment}
                  />
                  <Field
                    name="late_payment_fee_amount"
                    component={TextField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.latePayment.label.amount'
                    )}
                    style={style.textField}
                    validate={[validator.required]}
                    normalize={format.onlyNumbers}
                    format={validator.normalizeMoney}
                    fullWidth
                    disabled={!this.props.latePayment}
                    shouldHide={this.props.yardiEnabled}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.lateRent}
                  toggleName="enable_late_payment_reminder"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.lateRentEmails'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.lateRentEmails.description'
                  )}
                  shouldHide={this.props.yardiEnabled}
                >
                  <FieldArray
                    name="emailPreferences.late_payment_reminder"
                    component={EmailSettings}
                    selectFieldInterval={1}
                    selectFieldStart={1}
                    selectFieldEnd={5}
                    preferenceParameter={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.emailSettings.preferenceParameter.after'
                    )}
                    selectFieldName="late_payment_reminder"
                    disableSelect={!this.props.lateRent}
                    shouldHide={this.props.yardiEnabled}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.rentPaymentCreator}
                  toggleName="enable_create_monthly_payment"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.rentPaymentCreator'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.rentPaymentCreator.description'
                  )}
                  shouldHide={this.props.yardiEnabled}
                >
                  <FieldArray
                    name="emailPreferences.monthly_payment_creation"
                    component={EmailSettings}
                    selectFieldInterval={5}
                    selectFieldStart={5}
                    selectFieldEnd={20}
                    preferenceParameter={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.emailSettings.preferenceParameter.before'
                    )}
                    selectFieldName="monthly_payment_creation"
                    disableSelect={!this.props.rentPaymentCreator}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.upcomingRentEmail}
                  toggleName="enable_rent_due_reminder"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.upcomingRentEmails'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.upcomingRentEmails.description'
                  )}
                  shouldHide={this.props.yardiEnabled}
                >
                  <FieldArray
                    name="emailPreferences.rent_due_reminder"
                    component={EmailSettings}
                    selectFieldInterval={1}
                    selectFieldStart={1}
                    selectFieldEnd={5}
                    preferenceParameter={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.emailSettings.preferenceParameter.before'
                    )}
                    selectFieldName="rent_due_reminder"
                    disableSelect={!this.props.upcomingRentEmail}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleValue={this.props.upcomingRentEmailPad}
                  toggleName="enable_rent_due_PAD_reminder"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.padRemind'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.padRemind.description'
                  )}
                  shouldHide={this.props.yardiEnabled}
                >
                  <FieldArray
                    name="emailPreferences.rent_due_pad_reminder"
                    component={EmailSettings}
                    selectFieldInterval={1}
                    selectFieldStart={1}
                    selectFieldEnd={5}
                    preferenceParameter={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.emailSettings.preferenceParameter.before'
                    )}
                    selectFieldName="rent_due_pad_reminder"
                    disableSelect={!this.props.upcomingRentEmailPad}
                  />
                </PreferenceField>

                <PreferenceField
                  toggleName="enable_apply_link_after_booking_showing"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.addApplyLink'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.addApplyLink.description'
                  )}
                />
                <PreferenceField
                  toggleName="hide_payment_option_selection_page_during_application"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.hidePaymentOption'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.hidePaymentOption.description'
                  )}
                />
                <PreferenceField
                  toggleName="hide_bank_payment_details_autopay_during_application"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.hideBankPaymentDetails'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.hideBankPaymentDetails.description'
                  )}
                />
                <PreferenceField
                  toggleName="enable_allow_pap_details_delete_by_residents"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.allowPAPDeleteByResidents'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.allowPAPDeleteByResidents.description'
                  )}
                />
                <PreferenceField
                  toggleValue={this.props.surveyLinkAfterShowing}
                  toggleName="send_survey_link_after_showing_completion"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.toggleLabel.showingsSurveyLink'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.showingsSurveyLink.description'
                  )}
                >
                  <Field
                    name="survey_link_after_showing_completion"
                    component={TextField}
                    floatingLabelText={getTranslatedString(
                      'landlordPortal.companyPreferencesForm.emailNotifications.showingsSurveyLink.label.link'
                    )}
                    style={style.textField}
                    validate={[validator.required]}
                    fullWidth
                    disabled={!this.props.surveyLinkAfterShowing}
                  />
                </PreferenceField>
                <PreferenceField
                  toggleName="disable_application_auto_notify_references"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.disableApplicationAutoNotifyReferences.label'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreferencesForm.emailNotifications.disableApplicationAutoNotifyReferences.description'
                  )}
                  fullWidth
                />
                <PreferenceField
                  toggleValue={this.props.enableGuarantorEmails}
                  toggleName="enable_guarantor_emails"
                  toggleLabelName={getTranslatedString(
                    'landlordPortal.companyPreference.guarantorEmailsPreference'
                  )}
                  preferenceDescription={getTranslatedString(
                    'landlordPortal.companyPreference.turnOnGuarantorEmails'
                  )}
                  normalize={(v) => !!v}
                  onChange={(e) => {
                    this.handleParentGuarantorToggle(e.target.checked);
                  }}
                >
                  {this.state.childGuarantorPreferenceToggle && (
                    // childGuarantorPreferenceToggle is set to false.
                    // This change was from working on PR #3088
                    // when we decide to render this, we should think about
                    // what happens on the resident side as well because
                    // currently residents do not have ability to toggle on or off
                    // specific notification preferences.
                    <div>
                      <Field
                        name="guarantor_service_requests_emails"
                        component={Toggle}
                        disabled={!this.props.enableGuarantorEmails}
                        style={style.childToggle}
                        normalize={(v) => !!v}
                        label={
                          <strong style={{ fontWeight: '900', fontSize: '16px' }}>
                            {getTranslatedString(
                              'landlordPortal.companyPreference.serviceRequests'
                            )}
                          </strong>
                        }
                      />
                      <Field
                        name="guarantor_notices_emails"
                        component={Toggle}
                        disabled={!this.props.enableGuarantorEmails}
                        style={style.childToggle}
                        normalize={(v) => !!v}
                        label={
                          <strong style={{ fontWeight: '900', fontSize: '16px' }}>
                            {getTranslatedString('landlordPortal.companyPreference.notices')}
                          </strong>
                        }
                      />
                      <Field
                        name="guarantor_amenities_emails"
                        component={Toggle}
                        disabled={!this.props.enableGuarantorEmails}
                        style={style.childToggle}
                        normalize={(v) => !!v}
                        label={
                          <strong style={{ fontWeight: '900', fontSize: '16px' }}>
                            {getTranslatedString('landlordPortal.companyPreference.amenities')}
                          </strong>
                        }
                      />
                      <Field
                        name="guarantor_promotions_emails"
                        component={Toggle}
                        disabled={!this.props.enableGuarantorEmails}
                        style={style.childToggle}
                        normalize={(v) => !!v}
                        label={
                          <strong style={{ fontWeight: '900', fontSize: '16px' }}>
                            {getTranslatedString('landlordPortal.companyPreference.promotions')}
                          </strong>
                        }
                      />
                      <Field
                        name="guarantor_payments_emails"
                        component={Toggle}
                        disabled={!this.props.enableGuarantorEmails}
                        style={style.childToggle}
                        normalize={(v) => !!v}
                        label={
                          <strong style={{ fontWeight: '900', fontSize: '16px' }}>
                            {getTranslatedString('landlordPortal.companyPreference.payments')}
                          </strong>
                        }
                      />
                      <Field
                        name="guarantor_parcels_emails"
                        component={Toggle}
                        disabled={!this.props.enableGuarantorEmails}
                        style={style.childToggle}
                        normalize={(v) => !!v}
                        label={
                          <strong style={{ fontWeight: '900', fontSize: '16px' }}>
                            {getTranslatedString('landlordPortal.companyPreference.parcels')}
                          </strong>
                        }
                      />
                      <Field
                        name="guarantor_surveys_emails"
                        component={Toggle}
                        disabled={!this.props.enableGuarantorEmails}
                        style={{ width: '75%' }}
                        normalize={(v) => !!v}
                        label={
                          <strong style={{ fontWeight: '900', fontSize: '16px' }}>
                            {getTranslatedString('landlordPortal.companyPreference.surveys')}
                          </strong>
                        }
                      />
                    </div>
                  )}
                </PreferenceField>
              </div>
            </div>
          )}
          <FlatButton
            label={getTranslatedString('landlordPortal.companyPreferencesForm.label.update')}
            type="submit"
            primary={true}
            backgroundColor={AccentColor()}
            hoverColor="grey"
            style={style.button}
          />
        </div>
      </form>
    );
  }
};

const COMPANY_PREFERENCE_FORM = 'company_preferences';
const selector = formValueSelector(COMPANY_PREFERENCE_FORM);

const mapStates = (state, ownProps) => ({
  initialValues: state.companyDetails.companyPreferences,
  showAutomationSettings: selector(state, 'showAutomationSettings'),
  evictionEmail: selector(state, 'enable_eviction_email'),
  feeReminder: selector(state, 'enable_fee_due_reminder'),
  balanceOwingNotification: selector(state, 'balance_owing_notification'),
  latePayment: selector(state, 'enable_create_late_payment'),
  lateRent: selector(state, 'enable_late_payment_reminder'),
  rentPaymentCreator: selector(state, 'enable_create_monthly_payment'),
  upcomingRentEmail: selector(state, 'enable_rent_due_reminder'),
  upcomingRentEmailPad: selector(state, 'enable_rent_due_PAD_reminder'),
  bookingsReport: selector(state, 'enable_bookings_report'),
  tenantNameAndEmailChangeReport: selector(state, 'enable_tenant_name_and_email_change_reporter'),
  serviceRequestReport: selector(state, 'enable_service_request_reporter'),
  leasesReport: selector(state, 'enable_leases_report'),
  weeklyLeasesReport: selector(state, 'enable_weekly_leases_report'),
  flaggedNotifications: selector(state, 'notify_on_flag'),
  autocloseFixedTickets: selector(state, 'autoclose_fixed_tickets'),
  cancelledLeases: selector(state, 'cancelled_leases'),
  cancelledLeasesEmail: selector(state, 'cancelled_leases_email'),
  applicationDenialNotification: selector(state, 'enable_application_denial_notification'),
  applicationAutoApprovalNotification: selector(
    state,
    'enable_application_auto_approval_notification'
  ),
  passwordExpirationActive: selector(state, 'password_expiration_active'),
  leadInactiveAfterMoveout: selector(state, 'lead_inactive_after_moveout'),
  enableShowOnlyScheduledTickets: selector(state, 'enable_show_only_scheduled_tickets_to_workers'),
  enableWelcomePackageDelivery: selector(state, 'enable_welcome_package_delivery'),
  enableReinviteDysPriorMoveIn: selector(state, 'enable_reinvite_days_prior_movein'),
  enableReinviteDysAfterMoveIn: selector(state, 'enable_reinvite_days_after_movein'),
  enableSecondInvitationReminder: selector(state, 'enable_second_invitation_reminder'),
  enableTenantLegalNotices: selector(state, 'enable_tenant_legal_notices'),
  enablePortalAssistanceRequest: selector(state, 'enable_portal_assistance_request'),
  surveyLinkAfterShowing: selector(state, 'send_survey_link_after_showing_completion'),
  enableGuarantorEmails: selector(state, 'enable_guarantor_emails'),
  enableExternalAutopayMinDay: selector(state, 'enable_external_autopay_min_day'),
  minimumApplicantAge: selector(state, 'minimum_applicant_age'),
  applicationHelpLink: selector(state, 'application_help_link'),
  bookingHelpLink: selector(state, 'booking_help_link'),
  prorateType: selector(state, 'prorate_type'),
  tenantPaymentLink: selector(state, 'use_payment_link_for_tenants'),
  reviewClosedMaintenanceRequestsNoExpire: selector(
    state,
    'review_closed_maintenance_requests_no_expire'
  ),
  global_amenity_booking_restrictions: selector(state, 'global_amenity_booking_restrictions'),
  disable_reviewed_status_change_notification_to_resident: selector(
    state,
    'disable_reviewed_status_change_notification_to_resident'
  ),
  enableGoogleReviews: selector(state, 'google_reviews_active'),
  enableMaintenanceSurveys: selector(state, 'enable_tenant_maintenance_survey'),
  autoScheduleBatches: selector(state, 'auto_schedule_batches'),
  yardiEnabled: state.userTypes.yardiEnabled,
  yuhuPaymentsActive: state.userTypes.paymentProvider === 'paysafe',
  isAdmin: state.userTypes.admin,
});

const ConnectComponent = connect(mapStates);

const ReduxFormComponent = reduxForm({
  form: 'company_preferences',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  enableReinitialize: true,
});

export default compose(ConnectComponent, ReduxFormComponent)(CompanyPreferenceForm);
